/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import cx from 'classnames';
import $ from 'jquery';
import FileSaver from 'file-saver';
import { Icon, Modal, Header } from 'semantic-ui-react';
import api from '../../api';
import DeleteModal from '../Modal/DeleteModal';
import ExportModal from '../Modal/ExportModal';
import MoveFileModal from '../Modal/MoveFileModal';
import SPDXDocumentGenerator from '../SBOM/SPDXDocumentGenerator';
import CycloneDXDocumentGenerator from '../SBOM/CycloneDXDocumentGenerator';
import NISModal from '../NISTools/NISModal';
import VexGenerator from '../SBOM/VexGenerator';
import CBOMGenerator from '../SBOM/CBOMGenerator';
import {
  //SCANS_LABEL_ARCHIVE,
  REPORT_EXTENSION_CSV,
  REPORT_EXTENSION_EXCEL,
  REPORT_EXTENSION_JSON,
} from '../../constants/reports';
import moreBtn from '../../images/components/content_project_card/newRisk.png';
import normalBookmarkImg from '../../images/components/content_projects_list/bookmarkBtn (Version) (normal).png';
import activeBookmarkImg from '../../images/components/content_projects_list/bookmarkBtn (Version) (active).png';
import compareBtn from '../../images/icons/compare.png';
import moveFileIcon from '../../images/components/content_project_card/move-file-icon.svg';
//import historyIcon from '../../images/components/content_project_card/history-icon.svg';
import deleteIcon from '../../images/components/content_project_card/delete-icon.svg';
import exportIcon from '../../images/components/content_project_card/export-icon.svg';
import quickScan from '../../images/components/content_project_card/quickScan.png';
import ScanInfoModal from '../Modal/ScanInfoModal';
import WithRouter from '../Extensions/WithRouter';

class PolicyProjectCard extends Component {
  constructor(props) {
    super(props);
    this.modalAction = null;
    this.modalBody = null;
    this.modalHeader = null;
    this.modalSubBody = null;
    this.state = {
      isOpen: false,
      modalExportIsOpen: false,
      isDownloadingReport: false,
      isOpenMFM: false,
      isMovingFile: false,
      isOpenMSI: false,
      movingData: {},
      projectList: props.projectList,
      isSelectable: props.isSelectable,
      checkValues: props.checkValues,
      isOpenAlertModal: false,
      toExport: '',
      isOpenMCX: false,
      isOpenMCD: false,
      isOpenMNA: false,
      isShowSbom: false,
      isOpenMVX: false,
      activeMenuIndex: '',
      isOpenMCB: false,
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleExport = this.handleExport.bind(this);
    this.handleCardBookmarkChange = this.handleCardBookmarkChange.bind(this);
    this.handleCardVersionBookmarkChange = this.handleCardVersionBookmarkChange.bind(this);
    this.closeExportModal = this.closeExportModal.bind(this);
    this.downloadReport = this.downloadReport.bind(this);
    this.deletedCallback = this.deletedCallback.bind(this);
    this.handleMove = this.handleMove.bind(this);
    this.closeMoveFileModal = this.closeMoveFileModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleInfoItem = this.handleInfoItem.bind(this);
    this.handleLeakageList = this.handleLeakageList.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleSpdx = this.handleSpdx.bind(this);
    this.handleCycloneDx = this.handleCycloneDx.bind(this);
    this.handleNIASbom = this.handleNIASbom.bind(this);
    this.handleVexBom = this.handleVexBom.bind(this);
    this.handleSlideToggle = this.handleSlideToggle.bind(this);
    this.handleMoreMenu = this.handleMoreMenu.bind(this);
    this.setFileMove = this.setFileMove.bind(this);
    this.setCompareItem = this.setCompareItem.bind(this);
    this.handleCBOM = this.handleCBOM.bind(this);
  }

  componentDidMount() {
    $(document).on('mouseover', '.content_project_card .name', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    const { isSelectable, checkValues } = this.props;

    if (isSelectable && prevProps.isSelectable !== isSelectable) {
      this.setState({
        isSelectable,
      });
    }

    if (checkValues && prevProps.checkValues.length !== checkValues.length) {
      this.setState({
        checkValues,
      });
    }
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleLeakageList = () => {
    const { uploaded_file_id, name } = this.props.file;
    this.props.handleLeakageList(uploaded_file_id, name);
  };

  handleInfoItem = () => {
    this.setState({
      isOpenMSI: true,
    });
  };

  handleClick = () => {
    const { file, clickEvent } = this.props;
    clickEvent(file.uploaded_file_id);
  };

  handleDelete = () => {
    this.setState({
      isOpen: true,
    });
  };

  handleExport = () => {
    this.setState({
      modalExportIsOpen: true,
    });
  };

  handleSpdx = () => {
    this.setState({
      isOpenMCX: true,
    });
  };

  handleCycloneDx = () => {
    this.setState({
      isOpenMCD: true,
    });
  };

  handleVexBom = () => {
    this.setState({
      isOpenMVX: true,
    });
  };

  handleNIASbom = () => {
    this.setState({
      isOpenMNA: true,
    });
  };

  handleClose() {
    this.setState({
      isOpen: false,
    });
  }

  handleCBOM() {
    const { file, translate } = this.props;
    const { has_crypto } = file;

    if (has_crypto) {
      this.setState({
        isOpenMCB: true,
      });
    } else {
      this.modalAction = translate('modal.title.notice');
      this.modalBody = translate('modal.message.no_crypto_data');
      this.modalHeader = null;

      this.setState({
        isOpenAlertModal: true,
      });
    }
  }

  handleClickOutside = (event) => {
    const { activeMenuIndex } = this.state;
    const container = $('.content_project_card');
    if (container && container.has(event.target).length === 0) {
      if (activeMenuIndex !== '') {
        this.setState({
          isShowSbom: false,
          activeMenuIndex: '',
        });
      }
    }
  };

  handleSlideToggle = () => {
    const { isShowSbom } = this.state;
    this.setState({
      isShowSbom: !isShowSbom,
    });
  };

  handleMoreMenu = () => {
    const { file } = this.props;
    const { uploaded_file_id } = file;
    const { activeMenuIndex } = this.state;
    if (activeMenuIndex === uploaded_file_id) {
      this.setState({
        activeMenuIndex: '',
        isShowSbom: false,
      });
    } else {
      this.setState({
        activeMenuIndex: uploaded_file_id,
        isShowSbom: false,
      });
    }
  };

  setFileMove(obj, id) {
    this.setState({
      isMovingFile: true,
    }, () => {
      api.setFileMove({
        selected_project_id: obj.selectedProject.id,
        selected_project_version_id: obj.selectedProjectVersion.id,
      }, id)
        .then(() => {
          this.setState({
            isMovingFile: false,
            isOpenMFM: false,
          });
          this.props.updateFilePath(obj, id);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }

  setCompareItem() {
    this.props.setCompareItem(this.props.file);
  }

  handleCardVersionBookmarkChange = (e, pvid) => {
    const projectVersionId = pvid;
    api
      .toggleBookmark(
        {
          project_version_id: projectVersionId,
          view_point: 'policy',
        }
      )
      .then((response) => {
        const res = response.response;
        this.props.handleCardVersionBookmarkChange(
          this.props.cardIndex,
          projectVersionId,
          res.is_bookmark
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleCardBookmarkChange = (e, ufid) => {
    api
      .toggleBookmark(
        {
          uploaded_file_id: ufid,
          view_point: 'policy',
        }
      )
      .then((response) => {
        const res = response.response;
        this.props.handleCardBookmarkChange(this.props.cardIndex, ufid, res.is_bookmark);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleMove = () => {
    const { projectList } = this.state;
    const findProjectIndex = projectList.findIndex((item) => {
      return item.pid === this.props.file.project_id;
    });

    const findVersionGroup = projectList[findProjectIndex].upLoaded.filter((item) => {
      return item.project_version_id === this.props.file.project_version_id;
    });

    const rowData = {
      name: this.props.file.name,
      projectName: projectList[findProjectIndex].projectName,
      projectVersionName: findVersionGroup[0].project_version_name,
      uploaded_file_id: this.props.file.uploaded_file_id,
      project_id: this.props.file.project_id,
    };

    this.setState({
      movingData: rowData,
      isOpenMFM: true,
    });
  };

  handleCheckChange = (e) => {
    const { file, isSelectable } = this.props;
    if (!isSelectable || !file.has_manage_permission) {
      return;
    }
    this.props.handleCheckChange(e, { value: file.uploaded_file_id });
  };

  generateToken = (length) => {
    let i = 0;
    let result = '';
    const timeStamp = new Date();
    const components = [
      timeStamp.getYear(),
      timeStamp.getMonth(),
      timeStamp.getDate(),
      timeStamp.getHours(),
      timeStamp.getMinutes(),
      timeStamp.getSeconds(),
      timeStamp.getMilliseconds(),
    ];
    const id = components.join('');
    const charactersLength = id.length;

    for (i; i < length; i++) {
      result += id.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  };

  closeModal() {
    this.setState({
      isOpenMSI: false,
      isOpenAlertModal: false,
      isOpenMCX: false,
      isOpenMCD: false,
      isOpenMVX: false,
      isOpenMNA: false,
      isOpenMCB: false,
    });
  }

  closeExportModal() {
    this.setState({
      modalExportIsOpen: false,
      isDownloadingReport: false,
      toExport: '',
    });
  }

  closeMoveFileModal() {
    this.setState({
      isOpenMFM: false,
    });
  }

  downloadReport(exportFormat, exportType, toExport) {
    const { state, file, translate } = this.props;
    const { currentPrecisionLevel } = state.user;
    const token = this.generateToken(10);
    const downloadFormatMapping = {
      [REPORT_EXTENSION_CSV]: 'csv',
      [REPORT_EXTENSION_EXCEL]: 'xlsx',
      [REPORT_EXTENSION_JSON]: 'zip',
    };

    let type;
    let url;

    if (currentPrecisionLevel) {
      type = currentPrecisionLevel;
    } else {
      type = null;
    }

    if (type) {
      url = `/1/reports/${this.props.file.uploaded_file_id}/export?file_format=${exportFormat}&section=${exportType}&token=${token}&precision_level=${type}&export_to=${toExport}`;
    } else {
      url = `/1/reports/${this.props.file.uploaded_file_id}/export?file_format=${exportFormat}&section=${exportType}&token=${token}&export_to=${toExport}`;
    }

    this.setState({
      isDownloadingReport: true,
    });

    api
      .getExportedReport(url)
      .then((res) => {
        let data;
        let confidenceLevelName;
        const blob = new Blob([res], { type: 'application/octet-stream' });
        if (file.precisionLevel === 'narrow') {
          confidenceLevelName = 'high';
        } else if (file.precisionLevel === 'broad') {
          confidenceLevelName = 'low';
        } else {
          confidenceLevelName = file.precisionLevel;
        }
        const fileName = `${file.name}_${confidenceLevelName}.${downloadFormatMapping[exportFormat]}`;

        this.modalAction = translate('modal.title.notice');

        if (toExport === 's3') {
          data = JSON.parse(new TextDecoder().decode(res));
          const { bucket, key } = data.response;
          this.modalBody = translate('modal.message.export_send_s3');
          this.modalHeader = (
            <p className="modal_list" style={{ paddingTop: '10px' }}>
              <b>{translate('modal.title.bucket')}</b>
              &nbsp;
              {bucket}
            </p>
          );
          this.modalSubBody = (
            <p className="modal_list">
              <b>{translate('modal.title.file_storage_path')}</b>
              &nbsp;
              {key}
            </p>
          );
        } else if (toExport === 'email') {
          data = JSON.parse(new TextDecoder().decode(res));
          const { dest_email } = data.response;
          this.modalBody = translate('modal.message.export_send_email');
          this.modalHeader = translate('modal.message.export_send_to_email', { email: dest_email });
          this.modalSubBody = null;
        } else if (toExport === 'local') {
          FileSaver.saveAs(blob, fileName);
          this.modalBody = translate('modal.message.export_send_local');
          this.modalHeader = null;
          this.modalSubBody = null;
        }
        this.setState({
          isDownloadingReport: false,
          modalExportIsOpen: false,
          isOpenAlertModal: true,
          toExport,
        });
      })
      .catch((err) => {
        console.log(err);
        let jsonParse;
        const ArrayBufferView = Object.getPrototypeOf(Object.getPrototypeOf(new Uint8Array())).constructor;
        if (err.data instanceof ArrayBuffer || err.data instanceof ArrayBufferView) {
          jsonParse = JSON.parse(new TextDecoder().decode(err.data));
        } else {
          jsonParse = err.data;
        }
        const o = jsonParse.response;
        this.modalAction = translate('modal.title.attention');

        if (!o.error) {
          this.modalBody = translate('modal.error.unknow_error');
        }

        if (o.error === '422-002') { // recovery email
          this.modalBody = translate('modal.error.error_422_002_export');
        }

        if (o.error === '422-365') { // license expired
          this.modalBody = translate('system.message.license_expired');
        }

        if (o.error === '422-366') {
          this.modalBody = o.error_description;
        }

        if (o.error === '422-367') { // smtp error
          this.modalBody = translate('modal.error.error_422_368_jira');
        }

        if (o.error === '422-791') {
          this.modalBody = translate('modal.error.error_422_791_export');
        }

        this.modalHeader = null;
        this.modalSubBody = null;

        this.setState({
          isDownloadingReport: false,
          modalExportIsOpen: false,
          isOpenAlertModal: true,
        });

      });
  }

  deletedCallback() {
    this.props.deletedCallback();
  }

  render() {
    const iconStyle = {
      width: '14px',
      height: '14px',
      color: '#969696',
      fontWeight: 'bold',
      fontSize: '12px',
      marginRight: '5px',
    };

    const getItemStyle = (isDragging, draggableStyle) => {
      return {
        //userSelect: 'none',
        //background: isDragging && '#fae7ff',
        opacity: isDragging && 0.6,
        ...draggableStyle,
      };
    };

    const { translate, file, state } = this.props;
    const { has_leakage, use_scan_option, uploaded_file_id } = file;
    const {
      isSelectable,
      checkValues,
      isOpenAlertModal,
      toExport,
      isOpenMCX,
      isOpenMCD,
      isOpenMNA,
      isShowSbom,
      activeMenuIndex,
      isOpenMVX,
      isOpenMCB,
    } = this.state;

    return (
      <div
        className={cx('content_project_card_box', {
          version_group: this.props.file.project_version_name,
        })}
      >
        <div
          className={cx(
            'content_project_card',
            {
              select_mode: isSelectable,
            },
            {
              active: checkValues.indexOf(uploaded_file_id) > -1,
            },
            {
              more_menu_show: activeMenuIndex === uploaded_file_id
            }
          )}
          ref={this.props.draggableProvided.innerRef}
          {...this.props.draggableProvided.draggableProps}
          {...this.props.draggableProvided.dragHandleProps}
          style={getItemStyle(
            this.props.draggableSnapshot.isDragging,
            this.props.draggableProvided.draggableProps.style
          )}
          onClick={this.handleCheckChange}
          onKeyUp={this.handleCheckChange}
        >
          <div className="content_project_card_inner">
            {
              checkValues.indexOf(uploaded_file_id) > -1
              && <span className="active_mode"><Icon name="check" /></span>
            }
            <div className="content_project_card_header">
              <div className="name">
                { use_scan_option ? (<img src={quickScan} alt="" />) : null}
                <span>{this.props.file.name}</span>
              </div>
              <div
                className="more"
                onClick={this.handleMoreMenu}
                onKeyUp={this.handleMoreMenu}
              >
                <a>
                  <img src={moreBtn} alt="more" />
                </a>
              </div>
              <div className="more_menu">
                <ul>
                  <li>
                    <a onClick={this.handleInfoItem} onKeyUp={this.handleInfoItem}>
                      <Icon name="info" style={{ color: '#969696' }} />
                      {translate('card.menu.information')}
                    </a>
                  </li>
                  {
                    has_leakage ? (
                      <li>
                        <a onClick={this.handleLeakageList} onKeyUp={this.handleLeakageList}>
                          <Icon name="shield" style={{ color: '#969696' }} />
                          {translate('card.menu.leakage')}
                        </a>
                      </li>
                    ) : null
                  }
                  <li>
                    {
                      this.props.file.policy_count.total > 0 ? (
                        <a onClick={this.setCompareItem} onKeyUp={this.setCompareItem}>
                          <img src={compareBtn} alt="" />
                          {translate('card.menu.compare')}
                        </a>
                      ) : (
                        <a
                          style={{
                            cursor: 'default',
                            opacity: '.45',
                            color: '#dddddd',
                          }}
                        >
                          <img src={compareBtn} alt="" />
                          {translate('card.menu.compare')}
                        </a>
                      )
                    }
                  </li>
                  <li>
                    {
                      this.props.file.has_manage_permission ? (
                        <a onClick={this.handleMove} onKeyUp={this.handleMove}>
                          <img src={moveFileIcon} alt="" />
                          {translate('card.menu.move')}
                        </a>
                      ) : (
                        <a
                          style={{
                            cursor: 'default',
                            opacity: '.45',
                            color: '#dddddd',
                          }}
                        >
                          <img src={moveFileIcon} alt="" />
                          {translate('card.menu.move')}
                        </a>
                      )
                    }
                  </li>
                  <li>
                    <a
                      onClick={(e) => {
                        return this.handleCardBookmarkChange(e, this.props.file.uploaded_file_id);
                      }}
                      onKeyUp={(e) => {
                        return this.handleCardBookmarkChange(e, this.props.file.uploaded_file_id);
                      }}
                    >
                      {this.props.file.is_bookmark ? (
                        <Icon name="bookmark" style={iconStyle} />
                      ) : (
                        <Icon name="bookmark outline" style={iconStyle} />
                      )}
                      {translate('card.menu.bookmark')}
                    </a>
                  </li>
                  {
                    state.user.use_crypto ? (
                      <li>
                        <a
                          onClick={this.handleCBOM}
                          onKeyUp={this.handleCBOM}
                        >
                          <Icon name="download" style={iconStyle} />
                          CBOM
                        </a>
                      </li>
                    ) : null
                  }
                  <li>
                    <a
                      className="sbom"
                      onClick={this.handleSlideToggle}
                      onKeyUp={this.handleSlideToggle}
                    >
                      <img src={exportIcon} alt="" />
                      SBOM
                    </a>
                    <ul
                      className={cx(
                        'sub_menu',
                        {
                          active: isShowSbom,
                        },
                      )}
                    >
                      <li style={{ padding: '0 0 0 20px' }}>
                        <a
                          onClick={this.handleExport}
                          onKeyUp={this.handleExport}
                        >
                          <Icon name="download" style={iconStyle} />
                          {translate('card.menu.clarity')}
                        </a>
                      </li>
                      <li style={{ padding: '0 0 0 20px' }}>
                        <a
                          onClick={this.handleSpdx}
                          onKeyUp={this.handleSpdx}
                        >
                          <Icon name="download" style={iconStyle} />
                          {translate('card.menu.spdx')}
                        </a>
                      </li>
                      <li style={{ padding: '0 0 0 20px' }}>
                        <a
                          onClick={this.handleCycloneDx}
                          onKeyUp={this.handleCycloneDx}
                        >
                          <Icon name="download" style={iconStyle} />
                          CycloneDX
                        </a>
                      </li>
                      <li style={{ padding: '0 0 0 20px' }}>
                        <a
                          onClick={this.handleVexBom}
                          onKeyUp={this.handleVexBom}
                        >
                          <Icon name="download" style={iconStyle} />
                          VEX
                        </a>
                      </li>
                      <li style={{ padding: '0 0 0 20px' }}>
                        <a
                          onClick={this.handleNIASbom}
                          onKeyUp={this.handleNIASbom}
                        >
                          <Icon name="download" style={iconStyle} />
                          NIS
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    {this.props.file.has_manage_permission ? (
                      <a onClick={this.handleDelete} onKeyUp={this.handleDelete}>
                        <img src={deleteIcon} alt="" />
                        {translate('card.menu.delete')}
                      </a>
                    ) : (
                      <a
                        style={{
                          cursor: 'default',
                          backgroundColor: '#cccccc',
                        }}
                      >
                        <img src={deleteIcon} alt="" />
                        {translate('card.menu.delete')}
                      </a>
                    )}
                  </li>
                </ul>
              </div>
              <div
                className={cx('version', {
                  bookmark_version: this.props.file.project_version_name,
                })}
              >
                {this.props.file.project_version_name}
                <a
                  className="version_bookmark_button"
                  onClick={(e) => {
                    return this.handleCardVersionBookmarkChange(
                      e,
                      this.props.file.project_version_id
                    );
                  }}
                  onKeyUp={(e) => {
                    return this.handleCardVersionBookmarkChange(
                      e,
                      this.props.file.project_version_id
                    );
                  }}
                >
                  {this.props.file.project_version_is_bookmark ? (
                    <img src={activeBookmarkImg} alt="" className="active" />
                  ) : (
                    <img src={normalBookmarkImg} alt="" className="normal" />
                  )}
                </a>
              </div>
            </div>
            <div className="content_project_card_content">
              <div className="content_project_card_content_inner">
                <div
                  className="card_content"
                  style={{ cursor: 'pointer' }}
                  onClick={this.handleClick}
                  onKeyUp={this.handleClick}
                >
                  <div className="card_content_item big_item2 issues_card2">
                    <p className="title">{translate('card.menu.violated_policy')}</p>
                    <p className="value">{this.props.file.policy_count.total}</p>
                  </div>
                  <div className="card_content_item small_item issues_card2">
                    <p className="title">{translate('card.menu.component_lowercase')}</p>
                    <p className="value">{this.props.file.policy_count.component}</p>
                  </div>

                  <div className="card_content_item small_item issues_card2">
                    <p className="title">{translate('card.menu.security_lowercase')}</p>
                    <p className="value">{this.props.file.policy_count.security}</p>
                  </div>

                  <div className="card_content_item small_item issues_card2">
                    <p className="title">{translate('card.menu.license')}</p>
                    <p className="value">{this.props.file.policy_count.license}</p>
                  </div>

                  <div className="card_content_item small_item issues_card2">
                    <p className="title">{translate('card.menu.litigator')}</p>
                    <p className="value">{this.props.file.policy_count.litigator}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="content_project_card_footer">
              <p className="time">{this.props.file.uploaded_at}</p>
              <p className="name">{this.props.file.owner}</p>
            </div>
          </div>
        </div>
        <DeleteModal
          isOpen={this.state.isOpen}
          closeModal={this.handleClose}
          rowData={this.props.file}
          deletedCallback={this.deletedCallback}
          translate={translate}
        />
        <ExportModal
          isOpenMED={this.state.modalExportIsOpen}
          onClose={this.closeExportModal}
          handleModal={this.downloadReport}
          isDownloading={this.state.isDownloadingReport}
          birdView
          rowData={this.props.file}
          translate={translate}
        />
        <MoveFileModal
          isOpenMFM={this.state.isOpenMFM}
          closeModal={this.closeMoveFileModal}
          rowData={this.state.movingData}
          isMovingFile={this.state.isMovingFile}
          setFileMove={this.setFileMove}
          projectName={this.props.projectName}
          translate={translate}
        />
        <ScanInfoModal
          isOpenMSI={this.state.isOpenMSI}
          reportId={this.props.file.uploaded_file_id}
          closeModal={this.closeModal}
          translate={translate}
        />
        <SPDXDocumentGenerator
          isOpenMCX={isOpenMCX}
          reportId={file.uploaded_file_id}
          uploadedFileName={file.name}
          closeModal={this.closeModal}
          translate={translate}
        />
        <CycloneDXDocumentGenerator
          isOpenMCD={isOpenMCD}
          reportId={file.uploaded_file_id}
          closeModal={this.closeModal}
          translate={translate}
        />
        <VexGenerator
          isOpenMVX={isOpenMVX}
          reportId={file.uploaded_file_id}
          closeModal={this.closeModal}
          translate={translate}
        />
        <CBOMGenerator
          isOpenMCB={isOpenMCB}
          reportId={file.uploaded_file_id}
          fileName={file.name}
          closeModal={this.closeModal}
          translate={translate}
        />
        <NISModal
          isOpenMNA={isOpenMNA}
          reportId={file.uploaded_file_id}
          translate={translate}
          closeModal={this.closeModal}
        />
        <Modal open={isOpenAlertModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalAction}</h2>
                {
                  toExport === 's3' ? (
                    <Modal.Description>
                      <Header>
                        {this.modalBody}
                      </Header>
                      {this.modalHeader}
                      {this.modalSubBody}
                    </Modal.Description>
                  ) : (
                    <Modal.Description>
                      <Header>
                        {this.modalBody}
                      </Header>
                      <p className="modal_list">{this.modalHeader}</p>
                      <p>{this.modalSubBody}</p>
                    </Modal.Description>
                  )
                }

                <div className="button_wrap">
                  <a className="center_button" onClick={this.closeModal} onKeyUp={this.closeModal}>
                    {translate('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
PolicyProjectCard.defaultProps = {
  file: {},
};

export default WithRouter(inject('state')(observer(PolicyProjectCard)));
